import angular from 'angular';
import SignalRService from '@/shared/services/SignalRService';
import moment from 'moment';

angular.module('cxNotifications').directive('notificationBanner', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      template: require('./notificationBanner.html'),
      scope: true,
      controller: [
        '$scope',
        '$timeout',
        'localStorageService',
        '$translate',
        '$rootScope',
        function($scope, $timeout, localStorageService, $translate, $rootScope) {
          var storageKey = 'clx-bannerMessage';

          $scope.showUpdateMessage = false;
          $scope.customMessage = null;

          var shouldMessageBeDisplayed = function(bannerMessage) {
            if (!bannerMessage.visibleUntil) return false;

            const visibleUntil = moment.utc(bannerMessage.visibleUntil);
            return moment.utc().isBefore(visibleUntil);
          };

          var displayCustomMessage = message => {
            var language = $translate.use().split('-')[0];

            switch (language.toLowerCase()) {
              case 'en':
                $timeout(function() {
                  $scope.customMessage = message.textEn;
                }, 100);
                break;
              case 'fr':
                $timeout(function() {
                  $scope.customMessage = message.textFr;
                }, 100);
                break;
              case 'nl':
                $timeout(function() {
                  $scope.customMessage = message.textNl;
                }, 100);
                break;
            }
          };

          var displayIncidentMessage = message => {
            if (!message || !shouldMessageBeDisplayed(message)) return;
              displayCustomMessage(message.Arguments[0]);
          };

          var showMessage = bannerMessage => {
            if (bannerMessage.type.toLowerCase() === 'update') {
              $timeout(function() {
                $scope.showUpdateMessage = true;
                $scope.updateHour = bannerMessage.hour;
              }, 100);
            } else if (bannerMessage.type.toLowerCase() === 'custom') {
              displayCustomMessage(bannerMessage);
            }
          };

          var checkIfBannerMessagePresentInLocalStorage = function() {
            const bannerMessage = localStorageService.get(storageKey) || {};
            if (!bannerMessage || !bannerMessage.type) return;
            if (!shouldMessageBeDisplayed(bannerMessage)) return;
            showMessage(bannerMessage);
          };
          checkIfBannerMessagePresentInLocalStorage();

          const showVcdmUpdateMessage = () => {
            const startTimeUtc = moment.utc('06-08-2023 18:00', 'DD-MM-YYYY hh:mm');
            const endTimeUtc = moment.utc('12-08-2023 15:00', 'DD-MM-YYYY hh:mm');
            const now = moment.utc();
            if (now.isAfter(startTimeUtc) && now.isBefore(endTimeUtc)) {
              var language = $translate.use().split('-')[0];

              switch (language.toLowerCase()) {
                case 'en':
                  $timeout(function() {
                    $scope.showVcdmEnglish = true;
                  }, 100);
                  break;
                case 'fr':
                  $timeout(function() {
                    $scope.showVcdmFrench = true;
                  }, 100);
                  break;
                case 'nl':
                  $timeout(function() {
                    $scope.showVcdmDutch = true;
                  }, 100);
                  break;
              }
            }
          };

          if ($translate.isReady()) {
            showVcdmUpdateMessage();
          } else {
            // Still loading translations, wait for it to finish and then init translations
            $translate.onReady(() => {
              showVcdmUpdateMessage();
            });
          }

          var handleSignalRMessage = function(bannerMessage) {
            if (!bannerMessage.type) {
              console.warn('bannerMessage type was empty');
              return;
            }

            if (bannerMessage.type === 'vcdm') {
              showVcdmUpdateMessage();
              return;
            }

            if (bannerMessage.type === 'incident') {
              displayIncidentMessage(bannerMessage);
              return;
            }

            localStorageService.set(storageKey, bannerMessage);

            showMessage(bannerMessage);
          };

          const removeBannerMessage = () => {
            localStorageService.remove(storageKey);
            $scope.customMessage = null;
          }

          SignalRService.subscribe('bannerMessage', handleSignalRMessage);

          SignalRService.subscribe('incidentbanner', handleSignalRMessage);
          SignalRService.subscribe('removeIncidentBanner', removeBannerMessage);

          var deregistration = $rootScope.$on('$translateChangeSuccess', function() {
            checkIfBannerMessagePresentInLocalStorage();
          });
          $scope.$on('$destroy', deregistration);
        },
      ],
    };
  },
]);
